import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import Container from "react-bootstrap/Container";

import TournamentTopHeader from "./EuroTournamentComponents/TournamentTopHeader";
import Fixtures from "./EuroTournamentComponents/Fixtures";
import Leaderboard from "./EuroTournamentComponents/Leaderboard";
import MyPreGameSelections from "./EuroTournamentComponents/MyPreGameSelections";
import {useNavigate, useParams} from "react-router-dom";
import IconTooltip from "../../assets/images/eoro-2024/icon-tooltip-teal.svg";
import EuroCompetitionInstructions from "./EuroCompetition/EuroCompetitionInstructions";

const EuroTournament = (props) => {
    const {
        isMobile,
        leagueMatchDays,
        leagueId,
        leagueTeams,
        leagueGroups,
        userPoints,
        jackpot,
        showJackpot,
        entries,
    } = props;
    const navigate = useNavigate();
    const { tab, id } = useParams();

    // console.log("tab is >>>", tab, " and id is >>>>", id)

    // console.log("leagueMatchDays in tournament>>>", leagueMatchDays)
    const [selectedTab, setSelectedTab] = useState('my-pregame');
    const initialActiveMatchDay = leagueMatchDays?.find(matchDay => matchDay?.is_active);
    const [currentMatchDay, setCurrentMatchDay] = useState(initialActiveMatchDay);

    const [instructionModal, setInstructionModal]= useState(false);

    useEffect(() => {
        if (tab === 'fixtures') {
            if (!id) {
                const activeMatchDayId = initialActiveMatchDay?.id;
                if (activeMatchDayId !== undefined) {
                    navigate(`/euro-24/fixtures/${activeMatchDayId}`, { replace: true });
                }
            } else {
                setSelectedTab('fixtures');
                const matchDay = leagueMatchDays.find(matchDay => matchDay.id.toString() === id);
                if (matchDay) {
                    setCurrentMatchDay(matchDay);
                }
            }
        } else if (tab === 'leaderboard') {
            if (!id) {
                navigate(`/euro-24/leaderboard/overall`, { replace: true });
            } else {
                setSelectedTab('leaderboard');
            }
        } else if (tab === 'my-pregame') {
            setSelectedTab('my-pregame');
            if (id) {
                navigate('/euro-24/my-pregame', { replace: true });
            }
        } else if (tab) {
            setSelectedTab(tab);
        } else {
            setSelectedTab('my-pregame');
            navigate('/euro-24/my-pregame', { replace: true });
        }
    }, [tab, id, initialActiveMatchDay, leagueMatchDays, navigate]);


    const handleTabClick = (tab) => {
        setSelectedTab(tab);
        if (tab === 'fixtures') {
            const activeMatchDayId = initialActiveMatchDay?.id;
            if (activeMatchDayId !== undefined) {
                navigate(`/euro-24/fixtures/${activeMatchDayId}`);
            }
        } else if (tab === 'leaderboard') {
            navigate(`/euro-24/leaderboard/overall`);
        } else {
            navigate(`/euro-24/${tab}`);
        }
    };

    const renderTabSection = () => {
        return (
            <>
                <section className={`${isMobile ? "mt-2" : "mt-4"}`}>
                    <div className={"d-flex align-items-center justify-content-between"}>
                        <div
                            className={`d-flex flex-row align-items-center fw-400 text-white cabin ${isMobile ? "mx-3 font-15 px-3 justify-content-evenly gap-2" : "mx-5 font-25 justify-content-start gap-4"}`}>
                            <div
                                role="button"
                                onClick={() => handleTabClick('my-pregame')}
                                className={`${selectedTab === 'my-pregame' ? "skins-red-horizontal-line-tabs text-skins-teal text-nowrap px-1" : "skins-transparent-horizontal-line-tabs text-nowrap px-1"}`}
                            >
                                My Pre Game
                            </div>
                            <div
                                role="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    // setCurrentMatchDay(leagueMatchDays[0])
                                    handleTabClick('fixtures')
                                }}
                                className={`${selectedTab === 'fixtures' ? "skins-red-horizontal-line-tabs text-skins-teal text-nowrap px-1" : "skins-transparent-horizontal-line-tabs text-nowrap px-1"}`}
                            >
                                Fixtures
                            </div>
                            <div
                                role="button"
                                onClick={() => handleTabClick('leaderboard')}
                                className={`${selectedTab === 'leaderboard' ? "skins-red-horizontal-line-tabs text-skins-teal text-nowrap px-1" : "skins-transparent-horizontal-line-tabs text-nowrap px-1"}`}
                            >
                                Leaderboard
                            </div>

                        </div>
                        <div className={`${isMobile && "pe-4 pb-2"}`}>
                            <div role={"button"}  onClick={() => {
                                console.log("instruction modal");
                                setInstructionModal(true);
                            }}>
                                <img
                                    src={IconTooltip}
                                    className="img-fluid"
                                    alt="icon"
                                    height={isMobile? 20 : 30}
                                    width={isMobile? 20 : 30}
                                />
                            </div>
                        </div>
                    </div>

                    {
                        selectedTab === 'my-pregame' &&
                        <div
                            className={`${isMobile ? "pt-4 pb-5 bg-team-card-grey rounded-my-skins-top" : "skins-border-white p-3 rounded-4"}`}
                        >
                            <MyPreGameSelections
                                isMobile={isMobile}
                                leagueMatchDays={leagueMatchDays}
                                leagueId={leagueId}
                                leagueTeams={leagueTeams}
                                leagueGroups={leagueGroups}
                            />
                        </div>
                    }
                    {selectedTab === 'fixtures' &&
                        <div
                            className={`${isMobile ? "pt-4 pb-5 bg-team-card-grey rounded-my-skins-top" : "skins-border-white p-3 rounded-4"}`}
                            // className={`skins-border-white rounded-4 ${isMobile ? "mt-3 p-3" : " px-5 py-3"}`}
                        >
                            <Fixtures
                                isMobile={isMobile}
                                leagueMatchDays={leagueMatchDays}
                                leagueId={leagueId}
                                currentMatchDay={currentMatchDay}
                                setCurrentMatchDay={setCurrentMatchDay}
                            />
                        </div>

                    }
                    {selectedTab === 'leaderboard' &&
                        <div
                            // className={`skins-border-white p-3 rounded-4 ${isMobile ? "mt-3" : ""}`}
                            className={`${isMobile ? "pt-4 pb-5 bg-team-card-grey rounded-my-skins-top" : "skins-border-white p-3 rounded-4"}`}
                        >
                            <Leaderboard
                                isMobile={isMobile}
                                leagueMatchDays={leagueMatchDays}
                                leagueId={leagueId}
                            />
                        </div>
                    }

                </section>
            </>
        )
    }


    const renderMobile = () => {
        return (
            <>
                <TournamentTopHeader
                    isMobile={isMobile}
                    currentMatchDay={currentMatchDay}
                    selectedTab={selectedTab}
                    userPoints={userPoints}
                    jackpot={jackpot}
                    showJackpot={showJackpot}
                    entries={entries}
                />
                <div className={"pt-4"}>

                {renderTabSection()}
                </div>
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <Container>
                    <TournamentTopHeader
                        isMobile={isMobile}
                        currentMatchDay={currentMatchDay}
                        selectedTab={selectedTab}
                        userPoints={userPoints}
                        jackpot={jackpot}
                        showJackpot={showJackpot}
                        entries={entries}
                    />
                    {renderTabSection()}
                </Container>

            </>
        );
    }
    const render = () => {
        return (
            <section
            >
                <Helmet>
                    <title>Sportskins - Euro-2024</title>
                    <meta name="description" content="Sportskins- Euro-2024"/>
                </Helmet>

                {isMobile ? renderMobile() : renderDesktop()}
                {
                    instructionModal &&
                    <>
                        <EuroCompetitionInstructions
                            isMobile={isMobile}
                            showModal={instructionModal}
                            setShowModal={setInstructionModal}
                        />
                    </>
                }
            </section>
        );
    }

    return render();
}

export default EuroTournament;
